<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="toc">CONTENTS</h1>
<p class="toc1"><a href="#/OEBPS/c01.htm">1. <em>KATAL!</em></a></p>
<p class="toc1"><a href="#/OEBPS/c02.htm">2. SIGNS OF VIOLENCE</a></p>
<p class="toc1"><a href="#/OEBPS/c03.htm">3. <em>POORIE</em> AND <em>MUDRAS</em></a></p>
<p class="toc1"><a href="#/OEBPS/c04.htm">4. THE MISSING CLUE</a></p>
<p class="toc1"><a href="#/OEBPS/c05.htm">5. THE LIE</a></p>
<p class="toc1"><a href="#/OEBPS/c06.htm">6. THE STEEL BRACELET</a></p>
<p class="toc1"><a href="#/OEBPS/c07.htm">7. A GRIM ADDRESS</a></p>
<p class="toc1"><a href="#/OEBPS/c08.htm">8. DEAD END</a></p>
<p class="toc1"><a href="#/OEBPS/c09.htm">9. PRIVATE INVESTIGATION</a></p>
<p class="toc1"><a href="#/OEBPS/c10.htm">10. DANGEROUS GAME</a></p>
<p class="toc1"><a href="#/OEBPS/c11.htm">11. NIGHT WATCH</a></p>
<p class="toc1"><a href="#/OEBPS/c12.htm">12. A LIFE AT STAKE</a></p>
<p class="toc1"><a href="#/OEBPS/c13.htm">13. THE WITNESS</a></p>
<p class="toc1"><a href="#/OEBPS/c14.htm">14. CAUGHT!</a></p>
<p class="toc1"><a href="#/OEBPS/c15.htm">15. LIFE LINE</a></p>
<p class="toc1"><a href="#/OEBPS/c16.htm">16. THE CAPTIVE’S STORY</a></p>
<p class="toc1"><a href="#/OEBPS/c17.htm">17. THE YELLOW HAWK</a></p>
<p class="toc1"><a href="#/OEBPS/c18.htm">18. ATTACK!</a></p>
<p class="toc1"><a href="#/OEBPS/c19.htm">19. WIND AND WATER</a></p>
<p class="toc1"><a href="#/OEBPS/c20.htm">20. <em>KATAL</em> AGAIN</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?36da0d5c